import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';

import PibPage from '../PibPage/PibPage';
import TourGuideAiBrochure from '../TourGuideAiBrochure/TourGuideAiBrochure';
import SiteSeePage from '../SiteSeePage/SiteSeePage';
import MapTilesPage from '../MapTilesPage/MapTilesPage';
import MapOnlyPage from '../MapOnlyPage/MapOnlyPage';
import TestPage from '../TestPage/TestPage';
import FloorPlanPrintPage from '../FloorPlanPrintPage/FloorPlanPrintPage';

const NoChromeComponents = () => (

  <Switch>

    {/* These components behave as pages */}

    {/*
      TourGuide AI brochure links from before #1655 carried a literal `brochure`
      prefix: /brochure/<slug>/<token>. Prospects may still hold them, so they
      redirect to the current form until their tokens expire. Treat `brochure`
      as a reserved community slug.
    */}
    <Redirect
      exact
      from="/brochure/:communitySlug/:drupalNid"
      to="/:communitySlug/:drupalNid"
    />

    {/*
      Brochure links sent before the community segment existed are two segments
      long: /brochure/<token>. Without this they match nothing and the
      bookmark dead-ends in the router, so the lead resource's own recovery
      (ask which community, re-request scoped) never gets a chance to run.
      MUST stay above the route below, which would otherwise read `brochure`
      as the community slug.
    */}
    <Route
      path="/brochure/:drupalNid"
      exact
      component={TourGuideAiBrochure}
    />

    {/*
      TourGuide AI brochure: /<slug>/<token>, where the token is exactly 64 hex
      characters. Two segments, so it cannot collide with the 3-segment PibPage
      route below; the token shape is what keeps it from catching any other
      two-segment path.
    */}
    <Route
      path="/:communitySlug/:drupalNid([0-9a-f]{64})"
      exact
      component={TourGuideAiBrochure}
    />

    <Route
      path="/:communitySlug/:sanitizedTitle/:drupalNid"
      exact
      component={PibPage}
    />

    <Route
      path="/:communitySlug/:drupalBundleType/:sanitizedTitle/:drupalNid"
      exact
      component={FloorPlanPrintPage}
    />

    {/* These components are full screen */}
    <Route
      path="/map-tiles"
      exact
      component={MapTilesPage}
    />

    <Route
      path="/test"
      exact
      component={TestPage}
    />

    <Route
      path="/map-only"
      exact
      component={MapOnlyPage}
    />

    <Route
      path="/tourguide"
      exact
      component={SiteSeePage}
    />

    <Redirect from="/map-embed" to="/tourguide" />

  </Switch>
);

export default NoChromeComponents;
